<template>
  <div
    class="flex flex-row items-center gap-4 py-2 px-2 rounded"
    data-avatar-shape="square"
    :class="{
      'hover:bg-gray-200': !isSelected
    }"
  >
    <MaterialResourceAvatar
      :material-resource-id="item.id"
      size="large"
      hide-status
      flat
    />
    <div class="flex flex-1 flex-col gap-1">
      <h3 class="text-base leading-tight font-bold">
        {{ $trans(item.name) }}
      </h3>

      <div v-if="hasAvailabilityItems" class="flex w-full flex-col">
        <table class="border-separate border-spacing-y-1.5">
          <tbody>
            <AvailabilityItem
              v-for="(availabilityItem, key) in localAvailabilityItems"
              :key="key"
              :item="availabilityItem"
            />
          </tbody>
        </table>
      </div>
    </div>
    <div class="shrink-0">
      <BaseButton
        v-if="isSelected"
        :title="$t('button.delete')"
        icon="trash"
        color="danger"
        size="extra-small"
        @click="removeItem"
      />

      <BaseButton
        v-if="!isSelected"
        :title="$t('button.add')"
        icon="plus"
        size="extra-small"
        inverse-icon-order
        @click="addItem"
      />
    </div>
  </div>

  <ConfirmModal ref="availabilityAlertModal" />
</template>

<script>
import MaterialResourceAvatar from '@c/Avatar/MaterialResourceAvatar.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import AvailabilityItem from '@c/Dashboard/Content/Planning/components/AvailabilityItem.vue'
import ConfirmModal from '@c/addf-package/components/modal/ConfirmModal.vue'

export default {
  name: 'MaterialResourceSelectItem',
  components: {
    ConfirmModal,
    AvailabilityItem,
    BaseButton,
    MaterialResourceAvatar
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    availabilityVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    allMaterialResourcesAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['add-item', 'remove-item'],
  data() {
    return {}
  },
  computed: {
    hasAvailabilityItems() {
      return this.availabilityVisible && this.localAvailabilityItems.length > 0
    },
    localAvailabilityItems() {
      return this.allMaterialResourcesAvailabilityItems.filter(
        (availabilityItem) => availabilityItem.model_id === this.item.id
      )
    }
  },
  methods: {
    async addItem() {
      let response = true

      let confirm =
        !this.hasAvailabilityItems ||
        (await this.$refs.availabilityAlertModal.show({
          title: this.$t('alert.absence_alert'),
          message: this.$t(`alert.absence_alert_message_material-resource`, {
            name: this.$trans(this.item.name),
            event: this.event.title
          }),
          okButton: this.$t('button.add_anyway')
        }))

      if (confirm !== response) {
        response = confirm
      }

      if (response) {
        this.$emit('add-item', this.item)
      }
    },
    removeItem() {
      this.$emit('remove-item', this.item)
    }
  }
}
</script>
